export default __webpack_public_path__ + "static/media/Kitaplar.5b90ed8d.jpg";